import http from "../../api/axios";
import { IOrderQuery } from "../../model/orders/query";

class RecieptsService {
  getData = (params: IOrderQuery): Promise<any> =>
    http.get("/receipts", { params });

  getReceiptByNumber = (barcode: string): Promise<any> =>
    http.get(`/receipts/${barcode}`);

  printReceipt = (barcode: number): Promise<any> =>
    http.get(`/receipts/print/${barcode}`);

  getReceiptById = (id: number): Promise<any> => http.get(`/orders/${id}`);

  createReciept = (data: any): Promise<any> =>
    http.post("/receipts/rent", data);

  invalidReciept = (data: any): Promise<any> =>
    http.post("/receipts/invalid", data);

  refungReceipt = (data: any, id?: number): Promise<any> =>
    http.put(`/receipts/refund`, data);

  UpdateReceipt = (data: any, id?: number): Promise<any> =>
    http.put(`/receipts/update/${id}`, data);

  deleteReciept = (id: number): Promise<any> =>
    http.delete(`/receipts/delete/${id}`);

  // solveOrderIssue = (data: any, issueId: number): Promise<any> =>
  //   http.put(`/issues/update/${issueId}`, data);
}

export default RecieptsService;
